import { render } from "./TenantDetail.vue?vue&type=template&id=5661f35d&scoped=true"
import script from "./TenantDetail.vue?vue&type=script&lang=js"
export * from "./TenantDetail.vue?vue&type=script&lang=js"

import "./TenantDetail.vue?vue&type=style&index=0&id=5661f35d&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5661f35d"]])

export default __exports__